/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Compte bancaire rattaché à une personne.
 * @export
 * @interface CompteBancaireDto
 */
export interface CompteBancaireDto {
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireDto
     */
    personId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireDto
     */
    iban?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireDto
     */
    bic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireDto
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CompteBancaireDto
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompteBancaireDto
     */
    isSelected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompteBancaireDto
     */
    storedFileId?: string | null;
}

/**
 * Check if a given object implements the CompteBancaireDto interface.
 */
export function instanceOfCompteBancaireDto(value: object): value is CompteBancaireDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CompteBancaireDtoFromJSON(json: any): CompteBancaireDto {
    return CompteBancaireDtoFromJSONTyped(json, false);
}

export function CompteBancaireDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompteBancaireDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'personId': json['personId'] == null ? undefined : json['personId'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'label': json['label'] == null ? undefined : json['label'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'isSelected': json['isSelected'] == null ? undefined : json['isSelected'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
    };
}

export function CompteBancaireDtoToJSON(json: any): CompteBancaireDto {
    return CompteBancaireDtoToJSONTyped(json, false);
}

export function CompteBancaireDtoToJSONTyped(value?: CompteBancaireDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personId': value['personId'],
        'iban': value['iban'],
        'bic': value['bic'],
        'label': value['label'],
        'isDefault': value['isDefault'],
        'isSelected': value['isSelected'],
        'storedFileId': value['storedFileId'],
    };
}

